(function () {
  if (window.__awReviewSocialProof) return;
  window.__awReviewSocialProof = true;

  var widgetSelector = [
    '#judgeme_product_reviews',
    '.jdgm-widget.jdgm-review-widget',
    '.jdgm-review-widget',
    '[data-widget="review"][data-id]'
  ].join(',');

  function topLevelWidgets() {
    return Array.prototype.filter.call(document.querySelectorAll(widgetSelector), function (widget) {
      return !widget.parentElement || !widget.parentElement.closest(widgetSelector);
    });
  }

  function suppressWidgets() {
    topLevelWidgets().forEach(function (widget) {
      var host = widget.closest('.shopify-app-block, .reviews-redesigned__layout') || widget;
      host.hidden = true;
      host.setAttribute('data-aw-review-widget-suppressed', 'true');
    });
  }

  function cloneProof() {
    var template = document.getElementById('aw-review-social-proof-template');
    if (!template || !template.content) return null;

    var proof = template.content.firstElementChild.cloneNode(true);
    proof.classList.add('aw-review-proof--injected');
    return proof;
  }

  function reconcile() {
    var proof = document.querySelector('[data-aw-review-proof]');
    if (!proof) proof = cloneProof();
    if (!proof) return false;

    var widgets = topLevelWidgets();
    if (widgets.length) {
      var widget = widgets.find(function (candidate) {
        return candidate.getClientRects().length > 0;
      }) || widgets[0];
      var host = widget.closest('.shopify-app-block, .reviews-redesigned__layout') || widget;
      if (proof.nextElementSibling !== host) {
        host.insertAdjacentElement('beforebegin', proof);
      }
      suppressWidgets();
    } else if (!proof.isConnected) {
      var productMain = document.getElementById('site-main');
      if (!productMain) return false;
      productMain.appendChild(proof);
    }

    return true;
  }

  function start() {
    reconcile();

    var observer = new MutationObserver(function () {
      reconcile();
    });
    observer.observe(document.body, { childList: true, subtree: true });

    window.setTimeout(function () {
      reconcile();
      observer.disconnect();
    }, 10000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
